var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar',{attrs:{"admin":true,"items":_vm.items}}),_c('v-main',[_c('v-container',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}):[_c('ICDForm',{attrs:{"icd":_vm.icd}})]],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }